export const isNotNull = object => typeof object !== 'undefined' && object !== null && object !== ""
export const isNull = object => typeof object === 'undefined' || object === null || object === ""

// create deep copy of the object
export const copy = object => JSON.parse(JSON.stringify(object))
